import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    InputAdornment,
    TextField,
    Button,
    Typography,
    Alert,
} from '@mui/material';
import { EmailOutlined as EmailIcon, EmailSharp } from '@mui/icons-material';
import { sendForgotPasswordEmail } from '../store/actions/auth';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();

    const { loading, message, error } = useSelector(state => state.auth);

    const handleChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        dispatch(sendForgotPasswordEmail(email));
    };

    return (
        <Box sx={{ maxWidth: '450px' }}>
            <Typography
                variant="h3"
                sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    mb: 2,
                    fontSize: { xs: '1.75rem', sm: '2.25rem' },
                }}
            >
                Forgot Password
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: 'text.secondary',
                    mb: 5,
                    fontSize: '1rem',
                    lineHeight: 1.6,
                }}
            >
                Enter your email address and we'll send you a link to reset your password.
            </Typography>

            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <Box sx={{ mb: 4 }}>
                    <Typography
                        variant="body2"
                        sx={{ mb: 1, fontWeight: 500, color: 'text.primary' }}
                    >
                        Email Address
                    </Typography>
                    <TextField
                        id="email"
                        type="email"
                        placeholder="Enter your registered email"
                        value={email}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                        fullWidth
                        variant="outlined"
                        size="medium"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                fontSize: '1rem',
                            },
                        }}
                    />
                </Box>

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    startIcon={<EmailSharp />}
                    disabled={loading || !email}
                    sx={{
                        py: 1.75,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        fontWeight: 600,
                    }}
                >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>
            </form>

            {message && (
                <Alert severity="success" sx={{ mt: 4, fontSize: '0.95rem' }}>
                    {message}
                </Alert>
            )}

            {error && (
                <Alert severity="error" sx={{ mt: 4, fontSize: '0.95rem' }}>
                    {error}
                </Alert>
            )}
        </Box>
    );
}

export default ForgotPassword;
